<template>
    <p class="text-success">
        <i class="bi bi-info-circle-fill" :class="optional_class"></i>
        <slot/>
    </p>
</template>

<script>
export default {
    name: 'TextInfo',
    props: {
        optional_class: {
            type: String,
            default: ''
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    p {font-size: .9rem; text-indent: -0.8rem; padding-left: 1.8rem;}
    .bi {margin-right: .5rem;}
</style>
